import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import {
  Container,
  Box,
  Typography,
  AppBar,
  Toolbar,
  IconButton,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Chip,
  Button,
  CircularProgress,
} from '@mui/material';
import {
  ArrowBack,
  ExpandMore,
  Lightbulb,
  Quiz,
} from '@mui/icons-material';

const StudyModule = () => {
  const { area } = useParams();
  const [searchParams] = useSearchParams();
  const topic = searchParams.get('topic');
  const navigate = useNavigate();
  const [content, setContent] = useState([]);
  const [loading, setLoading] = useState(true);

  const areaNames = {
    'matematicas': 'Matemáticas',
    'lectura-critica': 'Lectura Crítica',
    'sociales': 'Sociales',
    'ciencias': 'Ciencias',
    'ingles': 'Inglés',
  };

  useEffect(() => {
    fetchContent();
  }, [area, topic]);

  const fetchContent = async () => {
    try {
      const token = localStorage.getItem('token');
      const url = topic
        ? `${process.env.REACT_APP_API_URL}/api/study/content/${area}?topic=${topic}`
        : `${process.env.REACT_APP_API_URL}/api/study/content/${area}`;
      
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setContent(response.data);
    } catch (error) {
      console.error('Error fetching content:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => navigate('/dashboard')}
            sx={{ mr: 2 }}
          >
            <ArrowBack />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            {areaNames[area] || area}
          </Typography>
          <Button 
            color="inherit" 
            startIcon={<Quiz />}
            onClick={() => navigate(`/exam/${area}`)}
          >
            Hacer Examen
          </Button>
        </Toolbar>
      </AppBar>

      <Container sx={{ mt: 4, mb: 4 }}>
        {loading ? (
          <Box display="flex" justifyContent="center" p={4}>
            <CircularProgress />
          </Box>
        ) : content.length === 0 ? (
          <Paper sx={{ p: 4, textAlign: 'center' }}>
            <Typography variant="h6" color="text.secondary">
              Contenido en construcción
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
              Pronto estará disponible el material de estudio para esta área
            </Typography>
          </Paper>
        ) : (
          <Box>
            <Typography variant="h5" gutterBottom fontWeight="bold">
              Material de Estudio
            </Typography>
            {content.map((topic, index) => (
              <Accordion key={index} sx={{ mb: 2 }}>
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  aria-controls={`panel${index}-content`}
                  id={`panel${index}-header`}
                >
                  <Typography variant="h6">{topic.title}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography paragraph>{topic.content}</Typography>
                  {topic.tips && topic.tips.length > 0 && (
                    <Box sx={{ mt: 2 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <Lightbulb sx={{ color: 'warning.main', mr: 1 }} />
                        <Typography variant="subtitle1" fontWeight="bold">
                          Tips
                        </Typography>
                      </Box>
                      {topic.tips.map((tip, tipIndex) => (
                        <Chip
                          key={tipIndex}
                          label={tip}
                          sx={{ m: 0.5 }}
                          variant="outlined"
                          color="primary"
                        />
                      ))}
                    </Box>
                  )}
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        )}
      </Container>
    </Box>
  );
};

export default StudyModule;

